import { FormattedMessage } from "react-intl";

const Automations = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.automations.content.body"
                    defaultMessage="Increase efficiency by replacing manual, time-consuming work with automated processes and workflows."
                />
            </p>
        </div>
    );
};

export default Automations;
